module.exports = __webpack_public_path__ + "img/codesnippetinvalidfill.2272a6ee.svg";